import React, { useState } from "react";
import styles from "./styles.module.scss";
import Pagination from "../../../components/Pagination/Pagination";
import Table from "./table";
import useTemplateStore from "../../../stores/templates";

const List = ({ setPage, getTemplateList, page, pageCount }) => {
  const templateList = useTemplateStore((state) => state.templateList);
  const totalItems = useTemplateStore((state) => state.totalItems);
  const itemsPerPage = useTemplateStore((state) => state.itemsPerPage);
  const handlePage = (pageValue) => {
    setPage(pageValue.selected + 1);
  };

  return (
    <div className={styles.card}>
      <div>
        <Table data={templateList} fetchData={getTemplateList} />
        <div className={styles.pagination}>
          <Pagination
            pageCount={pageCount}
            currentPage={page - 1}
            onPageChange={handlePage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default List;
